import React from "react";

import {
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Typography,
    Grid,
    Box,
    Chip,
    Divider,
    FormControl,
    FormLabel
} from "@mui/material";

import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

import GlobalTextField from "../../global-fields/GlobalTextField";

const StockLocationAccordion = ({
    formik,
    index,
    location,
    style,
    plusIcon,
    peaskSeasonLimit,
    handleLocationChange,
    handleAmountFieldChange,
    handleAddPeakSeason,
    handleRemovePeakSeason,
}) => {
// console.log('formik',formik);
// console.log('location',location);
// console.log('index',index);


const handlePeakSeasonAmountChange = (e, index, peakIndex) => {
  let rawValue = e.target.value;

  if (!rawValue.startsWith("$")) rawValue = "$" + rawValue;

  if (rawValue === "$" || rawValue === "$.") {
    formik.setFieldValue(
      `additional_locations.${index}.peak_season.${peakIndex}.peak_season_amount`,
      rawValue
    );
    return;
  }

  const [integerPart, decimalPart] = rawValue
    .replace(/[^0-9.]/g, "")
    .split(".");

  let formatted = "$";

  if (integerPart) {
    formatted += new Intl.NumberFormat("en-US").format(Number(integerPart));
  }

  if (decimalPart !== undefined) {
    formatted += "." + decimalPart.slice(0, 2);
  }

  formik.setFieldValue(
    `additional_locations.${index}.peak_season.${peakIndex}.peak_season_amount`,
    formatted
  );
};


const handleLocationAmountChange = (e, index, field) => {
  let rawValue = e.target.value;

  // Always start with $
  if (!rawValue.startsWith("$")) rawValue = "$" + rawValue;

  // Allow typing "$" or "$."
  if (rawValue === "$" || rawValue === "$.") {
    handleLocationChange(index, field, rawValue);
    return;
  }

  const [integerPart, decimalPart] = rawValue
    .replace(/[^0-9.]/g, "")
    .split(".");

  let formatted = "$";

  if (integerPart) {
    formatted += new Intl.NumberFormat("en-US").format(Number(integerPart));
  }

  if (decimalPart !== undefined) {
    formatted += "." + decimalPart.slice(0, 2);
  }

  // Save formatted value and update total
  handleLocationChange(index, field, formatted);
};
    return (

       <Accordion
  sx={{
    mb: 2,
    borderRadius: "12px !important",
    overflow: "hidden",
    boxShadow: "0 2px 8px rgba(0,0,0,0.08)",

    "&:before": {
      display: "none",
    },

    "&.Mui-expanded": {
      margin: "0 0 16px",
    },
  }}
>
  <AccordionSummary
    expandIcon={<ExpandMoreIcon sx={{ color: "#0B5D7A" }} />}
    sx={{
      backgroundColor: "#f5f5f5", // light blue
      borderBottom: "1px solid #D7EAF3",
      minHeight: 64,

      "&.Mui-expanded": {
        minHeight: 64,
      },

      "& .MuiAccordionSummary-content": {
        margin: "16px 0",
      },
    }}
  >
    <Typography
      sx={{
        fontWeight: 700,
        color: "#0B5D7A",
        fontSize: "18px",
      }}
    >
         Location{index + 1} - {location.location_name}
    </Typography>
  </AccordionSummary>

  <AccordionDetails
    sx={{
      background: "#fff",
      p: 4,
    }}
  >

                <Grid container spacing={2}>

                    <Grid size={{ xs: 12 }}>
                        <h2 className={style.formTitleh2}>
                            Amount(s) of Insurance Desired
                        </h2>
                    </Grid>

                    {/* On Stock */}

                    <Grid size={{ xs: 12, md: 8 }}>

                        <FormControl fullWidth>

                            <FormLabel sx={{ mb: 1 }}>
                                On Stock
                            </FormLabel>

                            <GlobalTextField
                                placeH="$"
                                type="text"
                                name={`additional_locations.${index}.on_stock`}
                                value={formik.values.additional_locations[index]?.on_stock || ""}
                                // onChange={(e) =>{
                                //     handleAmountFieldChange(
                                //         e,
                                //         index,
                                //         `additional_locations.${index}.on_stock`
                                //     );

                                //     handleLocationChange(
                                //         index,
                                //         "on_stock",
                                //         e.target.value
                                //     );
                                // }}
                                onChange={(e) =>
                                handleLocationAmountChange(e, index, "on_stock")
                            }
                            />

                        </FormControl>

                    </Grid>

                    {/* Peak Season */}

                    <Grid size={{ xs: 12 }}>

                        <div className={style.plusIconMain}>

                            <Box>

                                <h3 className={style.htitleText}>
                                    Peak Season
                                </h3>

                            </Box>

                            {location.peak_season.length < peaskSeasonLimit && (

                                <p
                                    style={{
                                        display: "flex",
                                        cursor: "pointer"
                                    }}
                                    onClick={() => handleAddPeakSeason(index)}
                                >

                                    <img
                                        src={plusIcon}
                                        alt=""
                                        style={{ marginRight: 5 }}
                                    />

                                    Add

                                </p>

                            )}

                        </div>

                    </Grid>

                    {location.peak_season.map((season, peakIndex) => (

                        <React.Fragment key={peakIndex}>

                            {peakIndex !== 0 && (

                                <Grid size={{ xs: 12 }}>

                                    <Divider>

                                        <Chip
                                            label={peakIndex + 1}
                                            onDelete={() =>
                                                handleRemovePeakSeason(
                                                    index,
                                                    peakIndex
                                                )
                                            }
                                        />

                                    </Divider>

                                </Grid>

                            )}

                            <Grid size={{ xs: 12, md: 4 }}>

                                <FormControl fullWidth>

                                    <FormLabel sx={{ mb: 1 }}>
                                        Amount
                                    </FormLabel>

                                    <GlobalTextField
                                        placeH="$"
                                        type="text"
                                        name={`additional_locations.${index}.peak_season.${peakIndex}.peak_season_amount`}
                                        //value={season.peak_season_amount}
                                        value={
                                            formik.values.additional_locations[index]?.peak_season?.[peakIndex]
                                                ?.peak_season_amount || ""
                                        }                                       
                                        // onChange={(e) =>
                                        //     formik.setFieldValue(
                                        //         `additional_locations.${index}.peak_season.${peakIndex}.peak_season_amount`,
                                        //         e.target.value
                                        //     )
                                        // }
                                        onChange={(e) =>
                                            handlePeakSeasonAmountChange(e, index, peakIndex)
                                        }
                                    />

                                </FormControl>

                            </Grid>

                            <Grid size={{ xs: 12, md: 4 }}>

                                <FormControl fullWidth>

                                    <FormLabel sx={{ mb: 1 }}>
                                        No. of Days
                                    </FormLabel>

                                    <GlobalTextField
                                        type="number"
                                        name={`additional_locations.${index}.peak_season.${peakIndex}.no_of_days`}
                                          value={
                                            formik.values.additional_locations[index]?.peak_season?.[peakIndex]
                                                ?.no_of_days || ""
                                        }                                       
                                        onChange={(e) =>
                                            formik.setFieldValue(
                                                `additional_locations.${index}.peak_season.${peakIndex}.no_of_days`,
                                                e.target.value
                                            )
                                        }
                                    />

                                </FormControl>

                            </Grid>

                        </React.Fragment>

                    ))}

                    {/* Money Locked */}

                    <Grid size={{ xs: 12 }}>
                        <h3 className={style.htitleText}>
                            On money in Locked Safe
                        </h3>
                    </Grid>

                    <Grid size={{ xs: 12, md: 8 }}>

                        <GlobalTextField
                            name={`additional_locations.${index}.on_money_locked_in_safe`}
                            value={
                                formik.values.additional_locations[index]?.on_money_locked_in_safe || ""
                            }
                            // onChange={(e) =>
                            //     handleLocationChange(
                            //         index,
                            //         "on_money_locked_in_safe",
                            //         e.target.value
                            //     )
                            // }
                             onChange={(e) =>
                                handleLocationAmountChange(e, index, "on_money_locked_in_safe")
                            }
                        />

                    </Grid>

                    {/* Money Robbery */}

                    <Grid size={{ xs: 12 }}>
                        <h3 className={style.htitleText}>
                           Money off premises
                        </h3>
                    </Grid>

                    <Grid size={{ xs: 12, md: 8 }}>

                        <GlobalTextField
                        placeH="$"
                        name={`additional_locations.${index}.money_robbery`}
                        value={
                            formik.values.additional_locations[index]?.money_robbery || ""
                        }
                        // onChange={(e) =>
                        //     formik.setFieldValue(
                        //         `additional_locations.${index}.money_robbery`,
                        //         e.target.value
                        //     )
                        // }
                         onChange={(e) =>
                                handleLocationAmountChange(e, index, "money_robbery")
                            }
                    />

                    </Grid>

                    {/* Patterns */}

                    <Grid size={{ xs: 12 }}>
                        <h3 className={style.htitleText}>
                            On patterns, Molds, Models and Dies
                        </h3>
                    </Grid>

                    <Grid size={{ xs: 12, md: 8 }}>

                       <GlobalTextField
                            placeH="$"
                            name={`additional_locations.${index}.on_patterns_mold_models`}
                            value={
                                formik.values.additional_locations[index]?.on_patterns_mold_models || ""
                            }
                            // onChange={(e) =>
                            //     handleLocationChange(
                            //         index,
                            //         "on_patterns_mold_models",
                            //         e.target.value
                            //     )
                            // }
                            onChange={(e) =>
                                handleLocationAmountChange(e, index, "on_patterns_mold_models")
                            }
                        />
                    </Grid>

                    {/* Furniture */}

                    <Grid size={{ xs: 12 }}>
                        <h3 className={style.htitleText}>
                            On Furniture, Fixtures, Tools, Machinery and Fittings
                        </h3>
                    </Grid>

                    <Grid size={{ xs: 12, md: 8 }}>

                       <GlobalTextField
                            placeH="$"
                            name={`additional_locations.${index}.on_furnitures`}
                            value={
                                formik.values.additional_locations[index]?.on_furnitures || ""
                            }
                            // onChange={(e) =>
                            //     handleLocationChange(
                            //         index,
                            //         "on_furnitures",
                            //         e.target.value
                            //     )
                            // }
                            onChange={(e) =>
                                handleLocationAmountChange(e, index, "on_furnitures")
                            }
                        />

                    </Grid>

                    {/* Tenant */}

                    <Grid size={{ xs: 12 }}>
                        <h3 className={style.htitleText}>
                            On Tenant's Interest
                        </h3>
                    </Grid>

                    <Grid size={{ xs: 12, md: 8 }}>

                       <GlobalTextField
                        placeH="$"
                        name={`additional_locations.${index}.on_tentants_interest`}
                        value={
                            formik.values.additional_locations[index]?.on_tentants_interest || ""
                        }
                        // onChange={(e) =>
                        //     handleLocationChange(
                        //         index,
                        //         "on_tentants_interest",
                        //         e.target.value
                        //     )
                        // }
                        onChange={(e) =>
                                handleLocationAmountChange(e, index, "on_tentants_interest")
                            }
                    />

                    </Grid>

                    {/* Total */}

                    <Grid size={{ xs: 12 }}>
                        <h3 className={style.htitleText}>
                            Total
                        </h3>
                    </Grid>

                    <Grid size={{ xs: 12, md: 8 }}>

                       <GlobalTextField
                            placeH="$"
                            disabled
                            name={`additional_locations.${index}.stock_total`}
                            value={
                                formik.values.additional_locations[index]?.stock_total || ""
                            }
                        />

                    </Grid>

                </Grid>

            </AccordionDetails>

        </Accordion>

    );

};

export default StockLocationAccordion;